import { mapState } from 'vuex'
import { userPrimaryRoles, userSecondaryRoles } from '../utils/constants'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo.userInfo
    }),
    hasKreaLicenseActive() {
      const { activeKreaLicense } = this.userInfo
      return activeKreaLicense
    },
    isKreaAuthor() {
      return this.hasKreaLicenseActive && this.userInfo.secondaryRoles.some(role => role.name === userSecondaryRoles.author)
    },
    isKreaApprovingAuthor() {
      return this.hasKreaLicenseActive && this.userInfo.secondaryRoles.some(role => role.name === userSecondaryRoles.approvingAuthor)
    },
    isKreaAdmin() {
      return this.hasKreaLicenseActive && this.userInfo.primaryRoles.some(role => role.name === userPrimaryRoles.admin)
    },
    hasKreaAccess() {
      return this.isKreaAuthor || this.isKreaApprovingAuthor || this.isKreaAdmin
    }
  }
}
